import { render, staticRenderFns } from "./SlotList.vue?vue&type=template&id=2b1edd3f&"
import script from "./SlotList.vue?vue&type=script&lang=js&"
export * from "./SlotList.vue?vue&type=script&lang=js&"
import style0 from "./SlotList.vue?vue&type=style&index=0&id=2b1edd3f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports